import Button from '@cybs-ui/components/lib/button';
import Checkbox from '@cybs-ui/components/lib/checkbox';
import IconMenu from '@cybs-ui/components/lib/icon-menu';
import config from '../config';
import Dropdown from './Dropdown';
import Link from './Link';
import Input from './Input';
import FilterInput from './FilterInput';
import StatusBadge from './StatusBadge';
import StaticField from './StaticField';
import Combobox from './Combobox';
import ActiveFilter from './ActiveFilter';

const COMPONENTS = config.components;

export const ComponentDictionary = {
  [COMPONENTS.CHECKBOX]: Checkbox,
  [COMPONENTS.INPUT]: Input,
  [COMPONENTS.DROPDOWN]: Dropdown,
  [COMPONENTS.ICON]: Button,
  [COMPONENTS.ICON_MENU]: IconMenu,
  [COMPONENTS.COMBOBOX]: Combobox,
  [COMPONENTS.LINK]: Link,
  [COMPONENTS.BUTTON]: Button,
  [COMPONENTS.ACTIVE_FILTER]: ActiveFilter,
  [COMPONENTS.FILTER_INPUT]: FilterInput,
  [COMPONENTS.FILTER_DROPDOWN]: Combobox,
  [COMPONENTS.STATUS_BADGE]: StatusBadge,
  [COMPONENTS.STATIC_FIELD]: StaticField
};

export const GridComponents = {
  Checkbox,
  Input,
  Dropdown,
  FilterDropdown: Combobox,
  FilterInput,
  IconMenu,
  Combobox,
  Icon: Button,
  Link,
  Button,
  StatusBadge,
  StaticField
};
